export default "__VITE_ASSET__a7bd7791__"